import { render, staticRenderFns } from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=template&id=7c22444e&scoped=true"
import script from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=script&lang=js"
export * from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=style&index=0&id=7c22444e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22444e",
  null
  
)

export default component.exports